import { render } from "./EventPublish.vue?vue&type=template&id=d6ec3af4"
import script from "./EventPublish.vue?vue&type=script&lang=js"
export * from "./EventPublish.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__